import { BatchLTLReplyAction } from 'types/BatchLTLReply';

import { BatchLTLShipmentStatus } from '../types';

export type BatchLTLStatusCounts = Record<BatchLTLShipmentStatus, number>;

export function getBatchLTLStatusCounts(
  statuses: BatchLTLShipmentStatus[]
): BatchLTLStatusCounts {
  const counts = Object.fromEntries(
    Object.values(BatchLTLShipmentStatus).map((status) => [status, 0])
  ) as BatchLTLStatusCounts;

  statuses.forEach((status) => {
    counts[status] += 1;
  });

  return counts;
}

// e.g. "Reply drafted with 5 shipments. 1 still needs rates."
export function getReplyConfirmationText(
  action: BatchLTLReplyAction,
  quotedCount: number,
  unquotedCount: number
): string {
  const quoted = `Reply ${action} with ${pluralize(quotedCount, 'shipment')}.`;
  if (unquotedCount === 0) {
    return quoted;
  }

  const verb = unquotedCount === 1 ? 'needs' : 'need';

  return `${quoted} ${unquotedCount} still ${verb} rates.`;
}

// Kit's bubble points at the panel, which has the full confirmation.
export function getReplyPointerText(
  action: BatchLTLReplyAction,
  remainingCount: number
): string {
  const replied = `Reply ${action}.`;
  if (remainingCount === 0) {
    return replied;
  }

  const verb = remainingCount === 1 ? 'needs' : 'need';

  return `${replied} ${pluralize(remainingCount, 'shipment')} still ${verb} rates in the panel below.`;
}

export function pluralize(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? '' : 's'}`;
}
